<template>
  <div :class="$style.wrap">
    <div :class="$style.header">
      <el-button
        @click="$router.push(path.TagSetLab())"
        size="mini"
        type="primary"
        >标签库管理</el-button
      >
    </div>
    <LyTable :list="list" ref="tableMain" />
    <EditDialog
      :show.sync="editShow"
      :tags="tags"
      :item="item"
      @callback="getList"
    />
  </div>
</template>

<script>
import tagsCol from "./tagsCol";
import { getTagList, getList } from "./api";
import EditDialog from "./editDialog";
export default {
  name: "tagSet",
  inject: ["path"],
  components: {
    EditDialog,
  },
  data() {
    return {
      list: [],
      editShow: false,
      item: null,
      tags: [],
    };
  },
  mounted() {
    this.getList();
    this.getTagList();
    this.$refs["tableMain"].init(this.tableData);
  },
  computed: {
    tableData() {
      return {
        columns: [
          {
            label: "标签组名称",
            prop: "tag_group_name",
          },
          {
            label: "当前标签",
            prop: "tags",
            component: tagsCol,
          },
        ],
        operate: {
          operateColumnsLabel: "操作",
          operateColumnsFixed: "right",
          operateColumnsDirection: "row",
          operateColumns: [
            {
              text: "设置标签",
              method: ({ row }) => {
                this.edit(row);
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    edit(row) {
      this.editShow = true;
      this.item = row;
    },
    async getList() {
      let { data } = await getList();
      this.list = data;
    },
    async getTagList() {
      let { data } = await getTagList();
      this.tags = data.list;
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  padding: 10px;
  background: #fff;
}
.header {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
</style>